<p class="emoji">¯\_(ツ)_/¯</p>
<p>{{ message || defaultMessage }}</p>
